import { useEffect, useCallback } from 'react';
import { Drawer, Form, message } from 'antd';

import request from '@/request';

import InputItem from '../../components/InputItem';
import SelectorItem from '../../components/SelectorItem';
import SaveButton from '../../components/SaveButton';

export default function EditDrawer({ open, onClose, initialData, onSave }) {
  const [form] = Form.useForm();
  const nameVal = Form.useWatch('name', form);
  const chargerVal = Form.useWatch('charger', form);
  const phoneVal = Form.useWatch('phone', form);
  const idCardVal = Form.useWatch('idCard', form);
  const cityVal = Form.useWatch('city', form);

  useEffect(() => {
    if (open && initialData) {
      // 编辑模式：设置表单初始值
      form.setFieldsValue({
        name: initialData.name,
        contact: initialData.phone,
      });
    } else if (!open) {
      // 关闭时重置表单
      form.resetFields();
    }
  }, [open, initialData, form]);

  const onConfirm = useCallback(async () => {
    try {
      const values = await form.validateFields();
      await request.post('/events/admin/leader', {
        name: values.name,
        phone: values.phone,
        contactName: values.charger,
        idCard: values.idCard,
        cityName: values.city.name,
        cityCode: values.city.areaCode,
      });
      message.success('创建成功');
      onSave?.();
      onClose();
    } catch (error) {}
  }, [form, onClose, onSave]);

  return (
    <Drawer
      title={`${initialData?.id ? '编辑' : '创建'}机构信息`}
      size={400}
      onClose={onClose}
      open={open}
      extra={<SaveButton text="保存" onSave={onConfirm} />}
    >
      <Form form={form} layout="vertical">
        <div className="space-y-4">
          <Form.Item
            name="name"
            rules={[{ required: true, message: '请输入机构名称' }]}
          >
            <InputItem
              label="机构名称"
              placeholder="请输入机构名称"
              value={nameVal}
              onChange={(v) => form.setFieldsValue({ name: v })}
              require
            />
          </Form.Item>

          <Form.Item
            name="charger"
            rules={[{ required: true, message: '请输入负责人姓名' }]}
          >
            <InputItem
              label="负责人姓名"
              placeholder="请输入负责人姓名"
              value={chargerVal}
              onChange={(v) => form.setFieldsValue({ charger: v })}
              require
            />
          </Form.Item>

          <Form.Item
            name="idCard"
            rules={[{ required: true, message: '请输入负责人身份证' }]}
          >
            <InputItem
              label="负责人身份证"
              placeholder="请输入负责人身份证"
              value={idCardVal}
              onChange={(v) => form.setFieldsValue({ idCard: v })}
              require
            />
          </Form.Item>

          <Form.Item
            name="phone"
            rules={[{ required: true, message: '请输入联系电话' }]}
          >
            <InputItem
              label="联系电话"
              placeholder="请输入联系电话"
              value={phoneVal}
              onChange={(v) => form.setFieldsValue({ phone: v })}
              require
            />
          </Form.Item>

          <Form.Item
            name="city"
            rules={[{ required: true, message: '请选择所在城市' }]}
          >
            <SelectorItem
              label="比赛城市"
              type="address"
              require
              value={cityVal}
              onChange={(v) => form.setFieldsValue({ city: v })}
            />
          </Form.Item>
        </div>
      </Form>
    </Drawer>
  );
}
